import { createTheme } from '@mui/material/styles';

export const bubbleBackgroundColor = '#EFF2F5';
export const lightBorderColor = '#DFE1EC';
export const avatarBackgroundColor = '#EDEDFD';

export const theme = createTheme({
  typography: {
    fontFamily: '"Noto Sans", "Roboto"',
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#4F4FEE',
      dark: '#373762',
      light: '#5D658E',
    },
    secondary: {
      main: '#5D658E',
      dark: '#7880AB',
    },
    background: {
      default: '#F7F8FA',
      paper: '#FCFCFD',
    },
    divider: '#C4C4C4',
    error: {
      main: '#BA1A1A',
      dark: '#D53459',
    },
    text: {
      primary: '#373762',
      secondary: '#5D658E',
    },
    success: {
      main: '#108461',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#F7F8FA',
        },
      },
    },
  },
});
